import React from "react";
import ImageGrid from "../../../../components/company_grid";
import Footer from "../../../../components/footer";
import FluidHeroSection from "../../../About/blog/FluidConnector/fluid-connector";
import FluidSection from "../../../About/blog/FluidConnector/fluid_page";

function Home() {
  return (
    <div>
      <FluidHeroSection />
      <FluidSection/>
      <ImageGrid />
      <Footer />
    </div>
  );
}

export default Home;
